import { useEffect, useState } from "react";
import { IPanelHomologacion } from "../../../../Interfaces/auxiliar/IOperador";
import { IResponseApiFluent, codigosRespuesta } from "../../../../Interfaces/base/IResponse";
import { IDataCreatePersona } from "../../../../Interfaces/IPersona";
import personaServicio from "../../../../services/persona/personaServicio";

export const UsePanelHomologar=(props:IPanelHomologacion)=>{
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading,setLoading]=useState<boolean>(false)
    const initial:IDataCreatePersona={
        apellidoPaterno: "",
        apellidoMaterno: "",
        primerNombre: "",
        segundoNombre: "",
        codigoRRHH: "",
        nroDOI: "",
        tipoDocumentoIdentidad: ""
    }
    const [request,setRequest]=useState<IDataCreatePersona>(initial)
    const reset=()=>{
        setMensaje("")
        setRequest(initial)
        setStatus(0)
        props.onDismiss()
    }
    const postCrearPersona = () => {
        setLoading(true)
        personaServicio.CrearPersona(request)
            .then((res) => {
                if (res.status == 200) {
                    setStatus(200)
                    setMensaje(res.data.mensaje);
                    setTimeout(() => {
                        props.reload?.();
                        reset()
                    }, 3000)
                } else {
                    setStatus(500)
                }
                setLoading(false)
            })
            .catch((e) => {
                if (
                    e.response?.data &&
                    'type' in e.response.data &&
                    'title' in e.response.data &&
                    'status' in e.response.data &&
                    'instance' in e.response.data &&
                    'errors' in e.response.data
                ) {
                    const errorResponse = e.response.data as IResponseApiFluent;
                    const mensajeError = errorResponse.errors.join('\n');
                    setMensaje(mensajeError);
                } else {
                    console.log('Error detallado:', e);
                    setMensaje("Error Inesperado");
                }
                setStatus(500);
                setLoading(false);
                setMensaje("")
            })
    }
    useEffect(() => {
        if (props.isOpen) {
            setRequest({
                ...request,
                apellidoPaterno: props.operador.apellidoPaterno??"",
                apellidoMaterno: props.operador.apellidoMaterno??"",
                primerNombre: props.operador.primerNombre??"",
                segundoNombre: props.operador.segundoNombre??"",
                codigoRRHH: props.operador.codigoRRHH??"",
                nroDOI: props.operador.nroDOI??"",
                tipoDocumentoIdentidad: props.operador.tipoDocumentoIdentidad??"",
                claveEnrolar: props.operador.operador??""
                
            })
        }
    }, [props.operador])
    return {mensaje,status,loading,request,setRequest,reset,postCrearPersona}
}